import { useState } from 'react'
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent'
import { Field } from 'formik'
import { Box, Button, Grid2, Tooltip, Typography } from '@mui/material'
import { DateFormField } from '../../shared/components/formfields/DataFormField'
import { Input_Width } from '../../shared/constants'
import { useApartmentListForCourse, useMarketingList } from '../../assets/api/useAdminApi'
import CustomDivider from '../../shared/utils/CustomDivider'
import { IdAutoCompleteField } from '../../shared/components/formfields/IdAutoCompleteField'
import useMarketingDetailStore from '../../store/useMarketingDetailStore'
import AddMarketingForm from '../admin/AddMarketingForm'
import EditIcon from '@mui/icons-material/Edit';
import { GridActionsCellItem } from '@mui/x-data-grid'
import TableFilterTemplate from '../../shared/utils/TableFilterTemplate'
import useAuthStore from '../../store/useAuthStore'
import { useApartmentOptions } from '../admin/option/ApartmentOption'

const CommonAddMarketing = ({ id }) => {
    const { marketingDetail, setMarketingDetail } = useMarketingDetailStore();
    const [filters, setFilters] = useState({});
    const [isShowMarketing, setIsShowMarketing] = useState(false)
   const {courseApartmentOption}=useApartmentOptions()
      const ApartmentOptions = courseApartmentOption?.options

    const { data: marketList, isLoading: isMarketingLoading } = useMarketingList({
        apartment_id: id,
        ...filters
    })
    const MarketColumns = [
        {
            field: "sr_no",
            headerName: "Sr No",
            flex: 0.5,
            renderCell: (params) => <Typography variant="body1">{params.value}</Typography>
        },
        {
            field: "apartment_name",
            headerName: "Apartment Name",
            width: 200,
            renderCell: (params) => <Typography variant="body2" fontSize={"12px"}>{params.value}</Typography>,
        },
        {
            field: "type_of_ads",
            headerName: "Type Of Ads",
            flex: 1.5,
            renderCell: (params) => <Typography variant="body2" my={2} fontSize={"12px"}>{params.value}</Typography>,
        },
        {
            field: "number_of_ads",
            headerName: "No. Of Ads",
            flex: 1.5,
            renderCell: (params) => <Typography variant="body2" my={2} fontSize={"12px"}>{params.value}</Typography>,
        },
        {
            field: "ads_amount",
            headerName: "Ads Amount",
            flex: 1.5,
            renderCell: (params) => <Typography variant="body2" fontSize={"12px"}>{params.value}</Typography>,
        },

        {
            field: "from_date",
            headerName: "From Date",
            flex: 1.5,
            renderCell: (params) => <Typography variant="body2" fontSize={"12px"}>{params.value}</Typography>,
        },
        {
            field: "to_date",
            headerName: "To Date",
            flex: 1.5,
            renderCell: (params) => <Typography variant="body2" fontSize={"12px"}>{params.value}</Typography>,
        },
        {
            field: "actions",
            type: "actions",
            headerName: "Actions",
            flex: 1,
            cellClassName: "actions",
            renderCell: (params) => (
                <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
                    <Tooltip title="Edit">
                        <GridActionsCellItem
                            key={0}
                            icon={<EditIcon />}
                            label="Edit"
                            onClick={() => {

                                setMarketingDetail(params?.row)

                            }}
                        />
                    </Tooltip>
                </Box>
            ),
        }

    ];
    return (
        <>
            <NormalContainerWithHeader headerText={"Add Marketing Ads"} RightContent={!(marketingDetail?.id || isShowMarketing) && (
                <Button variant="outlined" onClick={() => setIsShowMarketing(true)} style={{width:"20%"}}>Add</Button>
            )}>
                {
                    (isShowMarketing || marketingDetail?.id) &&
                    <AddMarketingForm inputWidth={Input_Width} ApartmentOption={ApartmentOptions} isLoadingApart={courseApartmentOption?.isLoading} />
                }

            </NormalContainerWithHeader>
            <CustomDivider />
            <TableFilterTemplate
                title="Marketing Ads List"
                columns={MarketColumns}
                rowsData={marketList?.data || []}
                isLoading={isMarketingLoading}
                filterInitialValues={filters}
                filterReset={() => setFilters({})}
                onApplyFilters={(f) => setFilters(f)}
                renderFilterFields={({ values }) => (
                    <>
                        {
                            !id && <Grid2 children size={12}>
                                <Field
                                    name="apartment_id"
                                    component={IdAutoCompleteField}
                                    options={ApartmentOptions}
                                    label="Select Apartment"
                                    maxDate={values.to_date || undefined}
                                    isLoading={courseApartmentOption?.isLoading}
                                />
                            </Grid2>
                        }
                        <Grid2 children size={12}>
                            <Field
                                name="from_date"
                                component={DateFormField}
                                label="From Date"
                                maxDate={values.to_date || undefined}

                            />
                        </Grid2>
                        <Grid2 children size={12}>
                            <Field
                                name="to_date"
                                component={DateFormField}
                                label="To Date"
                                minDate={values.from_date || undefined}

                            />
                        </Grid2>
                    </>
                )}
            />
        </>
    )
}

export default CommonAddMarketing